import { Box, Icon } from '@quintoandar-tokko/jopijs';
import { useEffect, useState } from 'react';
import style from './Checkbox.module.scss';

export default function Checkbox({
  checked,
  iconType = 'icon-aceptar',
  onChange,
  ...props
}) {
  const { className, onClick, ...rest } = props;
  const [check, setCheck] = useState(checked);

  const handleClick = () => {
    const newValue = !check;
    setCheck(newValue);

    // Si hay una función onChange proporcionada, llamarla con un evento simulado
    if (onChange) {
      onChange({ target: { checked: newValue } });
    }
  };

  useEffect(() => {
    setCheck(checked);
  }, [checked]);

  return (
    <Box
      className={`${style.container} ${check ? style.checked : ''} ${
        className || ''
      }`}
      onClick={handleClick}
      data-disabled={Boolean(props.disabled)}
      {...rest}
    >
      {check && <Icon icon={iconType} fontSize="12px" />}
    </Box>
  );
}
